module.exports = __webpack_public_path__ + "static/media/bringToFront.9d4f445f.svg";